import React, { useState, useEffect } from 'react';
import Header from '../Header';
import ContactUsFooter from '../ContactUs/ContactUsFooter';
import ChatBot from '../ChatBot/ChatBot';
import './HomePage.css';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Doctor Modal Component
const DoctorModal = ({ doctor, onClose }) => {
    if (!doctor) return null;

    return (
        <div className="doctor-modal-overlay" onClick={onClose}>
            <div className="doctor-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="doctor-close-button" onClick={onClose}>×</button>
                <img src={doctor.img} alt={doctor.name} className="doctor-modal-image" />
                <h2>{doctor.name}</h2>
                <p><strong>Specialty:</strong> {doctor.specialty}</p>
            </div>
        </div>
    );
};

const HomePage = () => {
    const [showScrollButton, setShowScrollButton] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedDoctor, setSelectedDoctor] = useState(null); // Fix the state definition here

    const services = [
        {
            img: "/pictures/PedPic.png",
            title: "Pediatrics",
            description: "When was your child’s last dental checkup?<br>Our pediatric dentists ensure your little one’s teeth are healthy and happy.",
            link: "/Pediatrics"
        },
        {
            img: "/pictures/ImplantsPic.png",
            title: "Implants",
            description: "Are you ready to restore your smile’s completeness?<br>Implants that look, feel, and function like natural teeth.",
            link: "/Implants"
        },
        {
            img: "/pictures/WhiteningPic.png",
            title: "Whitening",
            description: "Want a brighter, more radiant smile?<br>Professional whitening for a dazzling, head-turning look.",
            link: "/Whitening"
        },
        {
            img: "/pictures/newdesign.png",
            title: "ORAL PROPHYLAXIS",
            description: "Ready for a fresh, clean smile? <br> Our gentle cleaning ensures a healthy, plaque-free mouth.",
            link: "/OralProphylaxis"
        },
        {
            img: "/pictures/PartialDenPic.png",
            title: "Partial Denture",
            description: "Isn’t it time to fill those gaps and restore your smile?<br>Partial dentures for a seamless and functional solution.",
            link: "/PartialDenture"
        },
        {
            img: "/pictures/ExPic.png",
            title: "Extraction",
            description: "Dealing with a painful tooth?<br>Safe and comfortable extractions for a healthier smile.",
            link: "/Extraction"
        },
        {
            img: "/pictures/newdesign3.png",
            title: "RESTORATIVE",
            description: "Need to repair or renew your teeth? <br> Fillings, crowns, and more to restore your smile’s beauty and function.",
            link: "/Restorative"
        },
        {
            img: "/pictures/CompleteDenPic.png",
            title: "Complete Denture",
            description: "Are you ready to reclaim your smile?<br>Full dentures designed for comfort and a natural look.",
            link: "/CompleteDenture"
        },
        {
            img: "/pictures/OrthoPic.png",
            title: "Orthodontics",
            description: "Dreaming of a straighter smile?<br>Braces and aligners for a perfectly aligned future.",
            link: "/Orthodontics"
        },
        {
            img: "/pictures/CrownBridPic.png",
            title: "Crown And Bridge",
            description: "Need to restore or protect your teeth?<br>Crowns and bridges for a strong, beautiful smile..",
            link: "/CrownBridge"
        },
        {
            img: "/pictures/newdesign2.png",
            title: "FLUORIDE",
            description: "Want stronger, cavity-resistant teeth? <br> Fluoride treatments protect and strengthen your enamel.",
            link: "/Fluoride"
        },
        {
            img: "/pictures/VeneersPic.png",
            title: "Veneers",
            description: "Dreaming of a flawless smile?<br>Custom veneers for a picture-perfect appearance.",
            link: "/Veneers"
        },
        {
            img: "/pictures/EdodonticsPic.png",
            title: "Endodontics",
            description: "Is it time to save your natural tooth?<br>Root canal therapy to relieve pain and preserve your smile.",
            link: "/Endodontics"
        },
        {
            img: "/pictures/SurgicalProPic.png",
            title: "Surgical Procedure",
            description: "Are you ready to take the next step toward oral health?<br>Expert surgical solutions for a healthier, pain-free smile.",
            link: "/SurgicalPro"
        },
    ];

    const doctors = [
        {
            img: "/pictures/dr-hanna-grace.jpg", // Update with actual filename
            name: "Dr. Hanna Grace Custodio",
        },
        {
            img: "/pictures/dr-marissa.jpg", // Update with actual filename
            name: "Dr. Marissa Cawit",
        },
        {
            img: "/pictures/dr-kyra.jpg", // Update with actual filename
            name: "Dr. Kyra Baroma",
        }
    ];

    const aboutUsImages = [
        "/pictures/HGC-bg.jpg",
        "/pictures/clinic-interior.jpg",
        "/pictures/dental-team.jpg"
    ];

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollButton(window.scrollY > 200);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const itemsPerPage = 3;
    const totalPages = Math.ceil(services.length / itemsPerPage);

    const handleDotClick = (index) => {
        setCurrentPage(index);
    };

    const handlePrevClick = () => {
        setCurrentPage(prevPage => Math.max(0, prevPage - 1));
    };

    const handleNextClick = () => {
        setCurrentPage(prevPage => Math.min(totalPages - 1, prevPage + 1));
    };

    const visibleServices = services.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <div className="homepage-container">
            <Header />
            <div id="homepage-content"
                className="homepage-content"
                style={{
                    backgroundImage: 'url("/pictures/stock2.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <div className="homepage-text-section">
                    <h1>Expert Care for Your Teeth, Comfort for Your Soul.</h1>
                    <p>Your <strong>smile</strong> is our priority. With <strong>expert care and the latest technology</strong>, we ensure that your dental experience is comfortable, efficient, and tailored to your needs.</p>
                    <a href="/login" className="c-button c-button--appointment">
                        BOOK AN APPOINTMENT
                    </a>
                </div>
            </div>
            <div id="aboutus-container" className="about-us-container">
                <div className="about-us-content">
                    <div className="image-section">
                        <img src="/pictures/HGC-bg.jpg" alt="Dental Clinic" className="about-us-image" />
                    </div>
                    <div className="text-section">
                        <h1>Enhancing Smiles, Naturally.</h1>
                        <h3 className="subheading">Your smile is our passion.</h3>
                        <p>
                            <strong>HGC Dental Clinic,</strong> founded in January 2023 by <strong>Dr. Hannah Grace Custodio</strong>, is dedicated to providing exceptional dental care in a warm and comfortable environment. Our team of experienced professionals is committed to ensuring the highest standards of oral health for all our patients, offering a wide range of services from routine checkups to advanced treatments.
                        </p>
                        <p>
                            We believe in creating personalized care plans that cater to each individual’s unique needs, making sure every visit is both pleasant and effective. With a focus on <strong>patient comfort, advanced technology, and a compassionate approach</strong>, we strive to give you a smile that lasts a lifetime.
                        </p>
                        <div className="buttons-container">
                            <a href="/login" className="btn-quote">Request Quote</a>
                            <a href="#contact-us-content" className="btn-contact">Reach Out</a>
                        </div>
                    </div>
                </div>
            </div>

           {/* Meet Our Doctors Section */}
           <div className="meet-our-doctors-container">
                <h2>Meet Our Doctors</h2>
                <div className="doctors-grid">
                    {doctors.map((doctor, index) => (
                        <div key={index} className="doctor-card" onClick={() => setSelectedDoctor(doctor)}>
                            <img src={doctor.img} alt={doctor.name} className="doctor-image" />
                            <h3>{doctor.name}</h3>
                            <p>{doctor.specialty}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Doctor Modal */}
            <DoctorModal doctor={selectedDoctor} onClose={() => setSelectedDoctor(null)} />

            <div id="services-content" className="services-container">
                <h2>Inclusive Dental Services</h2>
                <div className="services-wrapper">
                    <button className="arrow-button left-arrow" onClick={handlePrevClick} disabled={currentPage === 0}>
                        &lt;
                    </button>
                    <div className="services-grid">
                        {visibleServices.map((service, index) => (
                            <div key={index} className="service-item">
                                <a href={service.link}>
                                    <img src={service.img} alt={service.title} />
                                    <h3>{service.title}</h3>
                                    <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
                                </a>
                            </div>
                        ))}
                    </div>
                    <button className="arrow-button right-arrow" onClick={handleNextClick} disabled={currentPage === totalPages - 1}>
                        &gt;
                    </button>
                </div>
                <div className="dots-container">
                    {Array.from({ length: totalPages }, (_, index) => (
                        <span
                            key={index}
                            className={`dot ${currentPage === index ? 'active' : ''}`}
                            onClick={() => handleDotClick(index)}
                        ></span>
                    ))}
                </div>
                <div className="buttons-container">
                    <a href="AllServices" className="btn-quote"> See all </a>
                </div>
            </div>

            <div id="contact-us-content" className="contact-us-container">
                <div className="contactus-content">
                    <div className="contactus-image">
                        <img src="/pictures/ContactUs.jpg" alt="Contact Us Illustration" />
                    </div>
                    <form className="contact-form">
                        <h2>Talk to Us</h2>
                        <div className="input-group">
                            <span className="icon">👤</span>
                            <input type="text" id="name" name="name" placeholder="Name" required />
                        </div>
                        <div className="input-group">
                            <span className="icon">📧</span>
                            <input type="email" id="email" name="email" placeholder="E-mail" required />
                        </div>
                        <div className="input-group">
                            <textarea id="message" name="message" placeholder="Message" rows="5" required></textarea>
                        </div>
                        <button type="submit" className="send-button">Send Message</button>
                    </form>
                </div>
                <div className="map-container">
                    <h2>Visit Us</h2>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61853.687922312216!2d120.69281222167967!3d14.319825200000016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x339629d61c5abe5d%3A0xa59a8879e84adeee!2sPoblete%20Dental%20Clinic!5e0!3m2!1sen!2sph!4v1732471716990!5m2!1sen!2sph"
                        width="600"
                        height="450"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Responsive Google Map"
                    ></iframe>
                </div>
            </div>
            <ContactUsFooter />
            <ChatBot />

            {showScrollButton && (
                <button className="scroll-to-top" onClick={scrollToTop}>↑</button>
            )}
        </div>
        //why??
    );
};

export default HomePage;